import { useCallback, useEffect, useState } from "react";
import { useDispatch } from "react-redux";

import Model from "@tripian/model";
import { api } from "@tripian/core";
import { saveNotification } from "../redux/action/user";

const useQuestionCompanion = () => {
  const [loadingQuestionsCompanion, setLoadingQuestionsCompanion] =
    useState<boolean>(true);
  const [questionsCompanion, setQuestionsCompanion] =
    useState<Model.Question[]>();

  const dispatch = useDispatch();

  const fetchQuestionsCompanion = useCallback(() => {
    setLoadingQuestionsCompanion(true);
    return api
      .questionsCompanion()
      .then((pQuestions: Model.Question[]) => {
        setQuestionsCompanion(pQuestions);
      })

      .catch(questionsCompanionError => {
        dispatch(
          saveNotification(
            Model.NOTIFICATION_TYPE.ERROR,
            "questionCompanion",
            "Fetch Companion Questions",
            questionsCompanionError
          )
        );
        throw questionsCompanionError;
      })
      .finally(() => {
        setLoadingQuestionsCompanion(false);
      });
  }, [dispatch]);

  useEffect(() => {
    fetchQuestionsCompanion();
  }, [fetchQuestionsCompanion]);

  // Re-fetch when the app language changes — questionsCompanion() is cached per-lang
  // server-side, but this hook otherwise only ever fetches once on mount.
  useEffect(() => {
    const handleLanguageChange = () => {
      fetchQuestionsCompanion();
    };
    window.addEventListener("languageChanged", handleLanguageChange);
    return () =>
      window.removeEventListener("languageChanged", handleLanguageChange);
  }, [fetchQuestionsCompanion]);

  return { loadingQuestionsCompanion, questionsCompanion };
};

export default useQuestionCompanion;
